/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_ReplyingInputs */

const en_admin_tickets_replying = /** @type {(inputs: Admin_Tickets_ReplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

const zh_admin_tickets_replying = /** @type {(inputs: Admin_Tickets_ReplyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送中…`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Admin_Tickets_ReplyingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_replying = /** @type {((inputs?: Admin_Tickets_ReplyingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_ReplyingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_replying(inputs)
	return zh_admin_tickets_replying(inputs)
});
export { admin_tickets_replying as "admin.tickets.replying" }